export const numeric = {
  getNumberFromString(value) {
    // replace all non-numeric characters without , and . and - (without thousand, decimal separator and negative minus(substract) sign)
    var regex1 = new RegExp('[^\\d.,-]', 'g')
    value = value.replace(regex1, '')

    // replace thousand separator with empty space
    var thousandSeparator = `\\${utils.locale.getLocaleThousandSeparator()}`
    regex1 = new RegExp(thousandSeparator, 'g')
    value = value.replace(regex1, '')

    // keep last decimal separator if there are more
    var decimalSeparator = `\\${utils.locale.getDecimalSeparator()}`
    regex1 = new RegExp('[' + decimalSeparator + '](?=.*[' + decimalSeparator + '])', 'g')
    value = value.replace(regex1, '')

    // get the string entered until numeric chars (to verify if there is any substractor in it)
    // this is for negative numbers entered
    regex1 = new RegExp('^\\D+', 'g')
    var prefixString = value.match(regex1)

    // replace all 'minus'(substract) signs from value
    regex1 = new RegExp('-', 'g')
    value = value.replace(regex1, '')

    // verify if there is any substractor char in the string entered until numeric chars
    // this is for negative numbers entered
    if (prefixString && prefixString.indexOf('-') > -1) {
      var substractorString = '-'
      substractorString += value
      value = substractorString
    }

    return value
  },

  setMaxNumberOfDigits(value, numberOfDigits) {
    var indexOfDecimalSeparator = value.indexOf(utils.locale.getDecimalSeparator())
    var decimalSepIsInValue = indexOfDecimalSeparator > -1

    if (decimalSepIsInValue) {
      var maximNrOfDigits = value.length - indexOfDecimalSeparator
      if (maximNrOfDigits > numberOfDigits) {
        value = value.substring(0, indexOfDecimalSeparator + numberOfDigits + 1)
        value = value.toString()
      }
    }
    return value
  },

  getNumberWithDecimals(value, digits) {
    if (!digits) digits = 2
    value = this.getNumberFromString(value)
    value = value ? parseFloat(value).toFixed(digits) : parseFloat(0).toFixed(digits)
    value = value.toString()
    return value
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/numeric.js